<template>
  <li :class="$style.tag">
    <router-link :class="$style.link" :to="`/tag/${tag.name}/`">
      #{{ tag.label }}
    </router-link>
  </li>
</template>

<script>
import cf from '@/mixins/commonFunctions.js';
// import Spacer from '@/components/Spacer';

export default {
  name: 'ArticleTagItem',
  mixins: [cf],
  // components: { Spacer },
  props: ['tag'],
};
</script>

<style lang="scss" module>
.tag {
  margin: 0 6px 8px 0;
}
.link {
  color: var(--font-black);
  cursor: pointer;
  padding: 0px 10px;
  border-radius: 24px;
  background-color: var(--lightgray);
  display: flex;
  font-size: 12px;
}
</style>
